import { IConfigAPI } from '../interface/config';
import { IEnv } from '../interface/util';

const DEFAULTS = {
    URL: 'https://api.ats-workspace.com',
    AUTH: {
        CLIENT_ID: 'MobileApplication.Test',
        CLIENT_SECRET: 'secr3t!MobileApplication.Test',
        GRANT_TYPE: 'password',
        USERNAME: 'demo',
        PASSWORD: '@Demo1',
    },
    EXTENSION: {
        AUTH: '/apptoken',
        SITEDATA: '/sites/app.GetMyZipPatchSite',
        MEDIADIFF: '/media/app.CalculateMyMediaDifference',
        MEDIA: '/media(%MEDIAID%)/app.GetFile',
        MEDIA_WITH_ACCESS_TOKEN: '/media(%MEDIAID%)/app.GetFile?access_token=%ACCESS_TOKEN%',
    },
};

function settings(env: IEnv): IConfigAPI {
    const config: IConfigAPI = {
        url: env.getString('REACT_APP_API_URL', DEFAULTS.URL),
        auth: {
            clientId: env.getString('REACT_APP_API_AUTH_CLIENTID', DEFAULTS.AUTH.CLIENT_ID),
            clientSecret: env.getString(
                'REACT_APP_API_AUTH_CLIENTSECRET',
                DEFAULTS.AUTH.CLIENT_SECRET,
            ),
            grantType: env.getString('REACT_APP_API_AUTH_GRANTTYPE', DEFAULTS.AUTH.GRANT_TYPE),
            username: env.getString('REACT_APP_API_AUTH_USERNAME', DEFAULTS.AUTH.USERNAME),
            password: env.getString('REACT_APP_API_AUTH_PASSWORD', DEFAULTS.AUTH.PASSWORD),
        },
        extension: {
            auth: env.getString('REACT_APP_API_EXTENSION_AUTH', DEFAULTS.EXTENSION.AUTH),
            siteData: env.getString(
                'REACT_APP_API_EXTENSION_SITEDATA',
                DEFAULTS.EXTENSION.SITEDATA,
            ),
            mediaDiff: env.getString(
                'REACT_APP_API_EXTENSION_MEDIADIFF',
                DEFAULTS.EXTENSION.MEDIADIFF,
            ),
            media: env.getString('REACT_APP_API_EXTENSION_MEDIA', DEFAULTS.EXTENSION.MEDIA),
            mediaWithAccessToken: env.getString(
                'REACT_APP_API_EXTENSION_MEDIA_WITH_ACCESS_TOKEN',
                DEFAULTS.EXTENSION.MEDIA_WITH_ACCESS_TOKEN,
            ),
        },
    };

    return config;
}

export default settings;
